export function getNameError(value: string, touched: boolean): string | null {
    if (!touched) return null
    if (value.length === 0) return 'Укажите имя.'
    const trimmed = value.trim()
    if (trimmed.length < 3) return 'Имя — не меньше 3 символов.'
    if (trimmed.length > 12) return 'Имя — не больше 12 символов.'
    return null
}

export function getPhoneError(value: string, touched: boolean): string | null {
    if (!touched) return null
    const digits = value.replace(/\D/g, '')
    if (digits.length === 0) return 'Укажите телефон.'
    if (digits.length !== 11 || !['7', '8'].includes(digits[0])) {
        return 'Укажите российский номер из 11 цифр.'
    }
    return null
}
